<template>
  <div class="status-dashboard-container container">
      <div class="col-12 px-3 pt-4">
        <div v-if = "CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN.length>0" class="alert-container mb-2" >
              <div class="fade-in-out alert alert-error" >
                <div><strong>{{CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN}}</strong></div>
              </div>
            </div>
        <div v-if="noSuppliersOnboarded">
          <span class="main-title no-supplier-headline">You don't have any recently onboarded suppliers</span>
          <div class="mt-2 no-supplier-headline">
            <support></support>
          </div>
        </div>
      </div>

      <div>
        <div class='row'>
          <div  v-if="allDataIsLoaded" class="col-12 col-lg-2">
            <div class="all-platform-categories-container mt-2">
              <all-platform-categories  @onSupplierRequestCategorySelected="onSupplierRequestCategorySelected" />
            </div>
          </div>

          <div class="pl-lg-1 col-lg-10 col-12" >
            <loading-spinner v-if="!allDataIsLoaded"></loading-spinner>
            <div v-if="!isLoading && allDataIsLoaded">
              <div class="col-12">
                <div v-if="supplierDraftData.length > 0 && validateCurrentRoute(CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.DRAFT_REQUESTS)">
                  <div class="main-title mb-2 align-with-table">Draft requests</div>
                  <span class="align-with-table font-italic">The below requests have not been submitted yet. To edit and submit them, please select "Edit".</span>
                  <drafts-status-list />
                </div>
              </div>

              <div class="col-12" :class="(this.$route.name === 'StatusDashboard' || this.$route.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.ALL_REQUESTS) && supplierDraftData.length > 0 ? 'mt-5': null">
                <div v-if="onBoardingReturnedRequests.length > 0 && validateCurrentRoute(CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.RETURNED_REQUESTS)">
                  <div class="main-title mb-2 align-with-table">Returned requests</div>
                  <span class="align-with-table font-italic">The below requests have been submitted but were returned. To edit and submit them, please select "Edit".</span>
                  <returned-requests-list @onViewCaseDetails="launchAgentStatusModal($event)" />
                </div>
              </div>

              <div class="col-12 " :class="((this.$route.name === 'StatusDashboard' || this.$route.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.ALL_REQUESTS)) ? 'mt-5': null">
                <div v-if="onBoardingPendingRequests.length > 0 && validateCurrentRoute(CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.RECENTLY_SUBMITTED_REQUESTS)">
                  <div class="main-title mb-2 align-with-table">Recently submitted</div>
                  <span class="align-with-table font-italic">The below requests have been submitted recently. If you do not want to proceed with the request, please select "Close".</span>
                  <RecentlySubmittedRITMList @onCaseClosed="updateDashboardRecords" @onViewCaseDetails="launchAgentStatusModal($event)" />
                </div>
              </div>

              <div class="col-12" :class="((this.$route.name === 'StatusDashboard' || this.$route.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.ALL_REQUESTS)) ? 'mt-5': null">
                <div v-if="onBoardingCompletedRequests.length > 0 && validateCurrentRoute(CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.COMPLETED_REQUESTS)">
                  <div class="main-title mb-2 align-with-table">Completed requests</div>
                  <span class="align-with-table font-italic">The below requests have been completed or cancelled.</span>
                  <CompletedRITMList @onViewCaseDetails="launchAgentStatusModal($event)" />
                </div>
              </div>
            </div>

            <div class="pl-4" v-if="!noSuppliersOnboarded && allDataIsLoaded">
              <div v-if="validateCategoryRecords && !isLoading" class="font-italic">You dont have any records for the requested category. Please choose a different category to view supplier requests.</div>
              <support></support>
            </div>

          </div>
        </div>
      </div>
  </div>
</template>


<script>
import DraftsStatusList from "@/components/DraftsStatusList";
import RecentlySubmittedRITMList from "@/components/RecentlySubmittedRITMList";
import CompletedRITMList from "@/components/CompletedRITMList";
import ReturnedRequestsList from "@/components/ReturnedRequestsList";
import { mapActions,mapGetters, mapMutations } from "vuex"
import LoadingSpinner from "@/components/LoadingSpinner";
import Support from "@/components/Support";
import AllPlatformCategories from "./AllPlatformCategories";
import CONSTANTS from "@/store/constants";
export default {
  components: {
    AllPlatformCategories,
    LoadingSpinner, DraftsStatusList, RecentlySubmittedRITMList, CompletedRITMList, ReturnedRequestsList, Support},
  data() {
    return {
      allDataIsLoaded: true,
    }
  },
  methods: {
    ...mapActions(['fetchUserDrafts','fetchAllOnBoardingRequests']),
    ...mapMutations(['setRitmStatusAccessPoint']),
    launchAgentStatusModal(caseNumber) {
      this.setRitmStatusAccessPoint(this.$route.path)
      this.$router.push({name: "RITMStatus", params: {ritm: caseNumber}})
    },
    validateCurrentRoute(route){
      return this.$route.name === "StatusDashboard" || this.$route.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.ALL_REQUESTS || this.$route.params.supplierRequestCategory === route
    },
    onSupplierRequestCategorySelected(category){
      this.categoryAccessMethods.clicked = true
      this.categoryAccessMethods.isAccessedViaDeeplink = false
      this.validateForDeepLinkAccess(category)
    },
    updateDashboardRecords() {
      this.allDataIsLoaded = false
      this.fetchAllOnBoardingRequests().then(() => {
        this.fetchUserDrafts().then(() => {
        }).finally(() => {
          this.allDataIsLoaded = true
        })
      })
    },
    validateForDeepLinkAccess(category){
        //The below condition checks for conditions when the dashboard is accessed via deeplink, toggled from created()
        if (category === undefined && (this.$router.currentRoute.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.ALL_REQUESTS ||
            this.$router.currentRoute.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.DRAFT_REQUESTS ||
            this.$router.currentRoute.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.RETURNED_REQUESTS ||
            this.$router.currentRoute.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.RECENTLY_SUBMITTED_REQUESTS ||
            this.$router.currentRoute.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.COMPLETED_REQUESTS)
            && !this.ritmStatusAccessPoint)
        {
          this.updateDashboardRecords()
        }
        //The below conditions checks for conditions when any of the category is clicked.
        else if ((this.categoryAccessMethods.clicked === true && category !== undefined)){
          this.$hhMixpanel.trackEvent(`Clicked on category: ${Object.values(CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES).find(requestType => requestType === category.tab)}`);
      }
        this.setRitmStatusAccessPoint('')
    }
  },
  computed: {
    ...mapGetters(['supplierDraftData','isLoading','onBoardingPendingRequests','onBoardingCompletedRequests','onBoardingReturnedRequests','categoryAccessMethods','ritmStatusAccessPoint']),
    noSuppliersOnboarded() {
      return !this.isLoading && !(this.supplierDraftData.length > 0) && !(this.onBoardingPendingRequests.length > 0) && !(this.onBoardingCompletedRequests.length > 0) && !(this.onBoardingReturnedRequests.length > 0) && this.allDataIsLoaded
    },
    validateCategoryRecords(){
      return (this.supplierDraftData.length === 0 && this.$router.currentRoute.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.DRAFT_REQUESTS) ||
          (this.onBoardingPendingRequests.length === 0 && this.$router.currentRoute.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.RECENTLY_SUBMITTED_REQUESTS) ||
          (this.onBoardingCompletedRequests.length === 0 && this.$router.currentRoute.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.COMPLETED_REQUESTS) ||
          (this.onBoardingReturnedRequests.length === 0 && this.$router.currentRoute.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.RETURNED_REQUESTS)
    }
  },

  created() {
    //The below check is for checking the conditions for the deeplink, if accessed via a deeplink , then do a full blown request.
    if (this.categoryAccessMethods.clicked === false && this.categoryAccessMethods.isAccessedViaDeeplink === true){
      this.validateForDeepLinkAccess()
    }
  }
}

</script>


<style>
.status-dashboard-container {
  min-height: 600px;
}

.no-supplier-headline{
  margin-left: 35px;
}

.all-platform-categories-container {
  max-width: 210px;
}

@media screen and (max-width: 500px) {
  .all-platform-categories-container {
    max-width: 100%;
  }
}
</style>